import { FormizoSchema } from "Components/LabIZO/Formizo/FormizoSchema.interface";

export const AnswerReviewSetting: FormizoSchema[] = [
  {
    header: "Answer Review Message",
  },
  {
    label: "TC",
    name: "SettingDoc.Config.Message.TC",
    format: "textarea",
    variant: "outlined",
  },
  {
    label: "SC",
    name: "SettingDoc.Config.Message.SC",
    format: "textarea",
    variant: "outlined",
  },
  {
    label: "EN",
    name: "SettingDoc.Config.Message.EN",
    format: "textarea",
    variant: "outlined",
  },
  {
    header: '"Yes" Button Label',
  },
  {
    label: "TC",
    name: "SettingDoc.Config.Yes.TC",
    format: "text",
    variant: "outlined",
  },
  {
    label: "SC",
    name: "SettingDoc.Config.Yes.SC",
    format: "text",
    variant: "outlined",
  },
  {
    label: "EN",
    name: "SettingDoc.Config.Yes.EN",
    format: "text",
    variant: "outlined",
  },
  {
    header: '"No" Button Label',
  },
  {
    label: "TC",
    name: "SettingDoc.Config.No.TC",
    format: "text",
    variant: "outlined",
  },
  {
    label: "SC",
    name: "SettingDoc.Config.No.SC",
    format: "text",
    variant: "outlined",
  },
  {
    label: "EN",
    name: "SettingDoc.Config.No.EN",
    format: "text",
    variant: "outlined",
  },
];
